import React from 'react';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

type AnimatedBackdropProps = {
  className?: string;
};

export default function AnimatedBackdrop({ className = '' }: AnimatedBackdropProps) {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
    >
      <svg
        className={`absolute -left-24 -top-20 h-[28rem] w-[28rem] opacity-55 ${
          reducedMotion ? '' : 'animate-[float_16s_ease-in-out_infinite]'
        }`}
        viewBox="0 0 500 500"
      >
        <defs>
          <radialGradient id="birdman-orb-cyan" cx="50%" cy="50%" r="60%">
            <stop offset="0%" stopColor="#2dd4bf" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.05" />
          </radialGradient>
        </defs>
        <circle cx="250" cy="250" r="250" fill="url(#birdman-orb-cyan)" />
      </svg>

      <svg
        className={`absolute -right-20 top-20 h-[24rem] w-[24rem] opacity-45 ${
          reducedMotion ? '' : 'animate-[float_18s_ease-in-out_infinite_reverse]'
        }`}
        viewBox="0 0 420 420"
      >
        <defs>
          <radialGradient id="birdman-orb-violet" cx="50%" cy="50%" r="65%">
            <stop offset="0%" stopColor="#8b5cf6" stopOpacity="0.75" />
            <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.04" />
          </radialGradient>
        </defs>
        <circle cx="210" cy="210" r="210" fill="url(#birdman-orb-violet)" />
      </svg>

      <svg
        className={`absolute bottom-0 left-1/3 h-28 w-[42rem] opacity-30 ${
          reducedMotion ? '' : 'animate-[pulse_6s_ease-in-out_infinite]'
        }`}
        viewBox="0 0 680 120"
      >
        <defs>
          <linearGradient id="birdman-wave" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#22d3ee" stopOpacity="0" />
            <stop offset="40%" stopColor="#22d3ee" stopOpacity="0.6" />
            <stop offset="60%" stopColor="#a78bfa" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#a78bfa" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M0,75 C120,25 220,115 340,75 C460,35 560,115 680,70"
          stroke="url(#birdman-wave)"
          strokeWidth="10"
          fill="none"
          strokeLinecap="round"
        />
      </svg>

      <svg
        className="absolute left-8 top-24 h-20 w-24 opacity-45"
        viewBox="0 0 120 90"
      >
        <path
          d="M12 62 C20 45, 42 30, 62 36 C56 46, 47 54, 34 59 C44 58, 53 60, 60 66 C48 70, 31 71, 18 66 Z"
          fill="#22c55e"
        >
          {!reducedMotion ? (
            <>
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 10 -8; 20 0; 10 8; 0 0"
                dur="12s"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                additive="sum"
                type="rotate"
                values="0 45 45; -4 45 45; 0 45 45"
                dur="2.8s"
                repeatCount="indefinite"
              />
            </>
          ) : null}
        </path>
      </svg>

      <svg
        className="absolute right-16 top-1/3 h-16 w-20 opacity-40"
        viewBox="0 0 100 80"
      >
        <path
          d="M14 53 C22 39, 39 29, 55 34 C50 43, 42 50, 31 54 C39 55, 47 58, 53 64 C43 67, 29 67, 18 62 Z"
          fill="#6366f1"
        >
          {!reducedMotion ? (
            <>
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; -14 6; -28 0; -14 -6; 0 0"
                dur="10s"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                additive="sum"
                type="rotate"
                values="0 40 40; 3 40 40; 0 40 40"
                dur="3.2s"
                repeatCount="indefinite"
              />
            </>
          ) : null}
        </path>
      </svg>
    </div>
  );
}

